export default "__VITE_ASSET__X9xiZf9D__"